import React from 'react';

import { Typography } from '@mui/material';
import clsx from 'clsx';
import { ToggleSwitch } from 'src/components/generic';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  toggleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

interface ToggleProps {
  text: string;
  toggle: (value: boolean) => void;
  value: boolean;
  className?: string;
  dataCy?: string;
  disabled?: boolean;
}

export function ToggleRow({
  className,
  dataCy,
  disabled,
  text,
  toggle,
  value,
}: ToggleProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={clsx(className, classes.toggleContainer)}>
      <Typography variant="body1">{text}</Typography>
      <ToggleSwitch
        dataCy={dataCy}
        disabled={disabled}
        toggle={() => toggle(!value)}
        toggled={value}
      />
    </div>
  );
}
